import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { DISCOUNT, useSellingPriceField } from '@makemydeal/dr-dash-components';
import { formatDollars } from '@makemydeal/dr-common-utils';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { LabelSeparator, LabelWithAction, SmallAction } from '../../../ScenarioGrid.style';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';

export const SellingPriceRowContent = ({ onDiscountActivate }: { onDiscountActivate: () => void }) => {
    const theme = useInterstateTheme();
    const { label, discountTotal, hasDiscountApplied, isItemizedDiscountsEnabledForDealer, isLocked, inputProps } =
        useSellingPriceField();
    const inputId = useScenarioCellId('sellingPrice');
    const discountLabel = hasDiscountApplied ? `${DISCOUNT}${formatDollars(discountTotal * -1)}` : DISCOUNT;

    return (
        <ScenarioRow
            rowKey="sellingPrice"
            label={
                <LabelWithAction theme={theme}>
                    <label htmlFor={inputId} data-testid="selling-price-label">
                        {label}
                    </label>
                    {isItemizedDiscountsEnabledForDealer && (
                        <>
                            <LabelSeparator theme={theme} aria-hidden />
                            <RowLabelAction onActivate={onDiscountActivate} disabled={isLocked} testId="add-dealer-discount-action">
                                <SmallAction>{discountLabel}</SmallAction>
                            </RowLabelAction>
                        </>
                    )}
                </LabelWithAction>
            }
        >
            <NumericInput {...inputProps} id={inputId} displayLabel={false} />
        </ScenarioRow>
    );
};
